@file:Suppress("ktlint:standard:backing-property-naming")

package com.nonopn.icons

import androidx.compose.material.icons.Icons
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import androidx.compose.ui.graphics.StrokeCap.Companion.Round as strokeCapRound
import androidx.compose.ui.graphics.StrokeJoin.Companion.Round as strokeJoinRound

public val Icons.Rounded.Folder: ImageVector
    get() {
        if (_folder != null) {
            return _folder!!
        }
        _folder =
            Builder(
                name = "Folder",
                defaultWidth = 40.0.dp,
                defaultHeight = 40.0.dp,
                viewportWidth = 24.0f,
                viewportHeight = 24.0f,
            )
                .apply {
                    path(
                        fill = SolidColor(Color(0x00000000)),
                        stroke = SolidColor(Color(0xFF000000)),
                        strokeLineWidth = 2.0f,
                        strokeLineCap = strokeCapRound,
                        strokeLineJoin = strokeJoinRound,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(22.0f, 19.0f)
                        arcToRelative(2.0f, 2.0f, 0.0f, false, true, -2.0f, 2.0f)
                        horizontalLineTo(4.0f)
                        arcToRelative(2.0f, 2.0f, 0.0f, false, true, -2.0f, -2.0f)
                        verticalLineTo(5.0f)
                        arcToRelative(2.0f, 2.0f, 0.0f, false, true, 2.0f, -2.0f)
                        horizontalLineToRelative(5.0f)
                        lineToRelative(2.0f, 3.0f)
                        horizontalLineToRelative(9.0f)
                        arcToRelative(2.0f, 2.0f, 0.0f, false, true, 2.0f, 2.0f)
                        close()
                    }
                }
                .build()
        return _folder!!
    }

private var _folder: ImageVector? = null
